import API from './'

const collection = {

	/**
	 * Get a list of collections.
	 */
	list(params={}, config={})
	{
		let url = API.getUrl(`collections`)

		return API.client().get(url, { params, ...config })
	},

	/**
	 * Get one collection details.
	 */
	one(slug, params={}, config={})
	{
		let url = API.getUrl(`collection/${slug}`)

		return API.client().get(url, { params, ...config })
	},

}

export default collection